import {
  RECORD_PRINTINFO,
  RECORD_USERID,
  RECORD_PLATFORMINFO,
  RECORD_PLATFORMINFO_LOCAL,
  RECORD_ORDERINFO,
  RECORD_USERINFO,
  RECORD_SPECINFO,
  RECORD_PROCESSED_PHOTO,
  RECORD_SELECTED_BG,
  RECORD_SEARCH_RESULTS,
  RECORD_LAST_SEARCH,
  RECORD_HOTSEARCH,
  RECORD_SERVICE_TEL,
  RECORD_CONSIGNEE_INFO,
  RECORD_PRICE,
  RECORD_PRINT_QTY,
  RECORD_PRINTPRICE,
  SET_LOADING,
  HANDLE_TRANCE,
  MAKE_PHOTO,
  UPDATE_PAY_LIST,
  RECORD_EXTRAINFO,
  SETRULECOLOR,
  UPDATEGROUPLISTPRICE,
  ADDGROUPLIST,
  DELGROUPLIST,
  SETGROUPLISTNUM,
  SETPRINTEXTRA,
  EXTRAINIT
} from './mutation-types';

import {
  setStorage
} from '../utils/utils'

export default {
  [RECORD_USERID](state, userId) {
    state.userId = userId;
  },
  //单独存储不涉及localstorage存储的，通常是从localstorage获取到的值放入vuex用这个方法
  [RECORD_PLATFORMINFO](state, platformInfo) {
    state.platformInfo = platformInfo;
  },
  //涉及localstorage存储的，通常不是从localstorage获取到的值放入vuex用这个方法
  [RECORD_PLATFORMINFO_LOCAL](state, platformInfo) {
    state.platformInfo = platformInfo;
    localStorage.setItem(`${platformInfo.appId}platformInfo`, JSON.stringify(platformInfo))
  },
  [RECORD_PRINTINFO](state, printInfo) {
    state.printInfo = printInfo;
  },
  [RECORD_USERINFO](state, openId) {
    state.openId = openId;
    setStorage('openId', openId);
  },

  [RECORD_ORDERINFO](state, orderInfo) {
    state.orderInfo = orderInfo;
  },

  //调用此方法需要设置本地存储用于项目与小程序跳转保存vuex数据
  [RECORD_PROCESSED_PHOTO](state, processedPhoto) {
    state.processedPhoto = processedPhoto;
    localStorage.setItem("makephoto",JSON.stringify(processedPhoto))
  },
  //调用此方法是因为数据就是从本地存储拿到的不需要重新再设置一次存储
  [MAKE_PHOTO](state, processedPhoto) {
    state.processedPhoto = processedPhoto;
  },

  [RECORD_SPECINFO](state, specInfo) {
    state.specInfo = specInfo;
  },

  [RECORD_SELECTED_BG](state, bgColor) {
    state.bgColor = bgColor;
  },
  [RECORD_SEARCH_RESULTS](state, searchResults) {
    state.searchResults = searchResults;
  },
  [RECORD_LAST_SEARCH](state, lastSearchWord) {
    state.lastSearchWord = lastSearchWord;
  },
  [RECORD_HOTSEARCH](state, hotSearch) {
    state.hotSearch = hotSearch;
  },
  [RECORD_SERVICE_TEL](state, serviceTelNumber) {
    state.serviceTelNumber = serviceTelNumber;
  },
  [RECORD_CONSIGNEE_INFO](state, consigneeInfo) {
    state.consigneeInfo = consigneeInfo;
  },
  [RECORD_PRICE](state, price) {
    state.price = price;
  },
  [RECORD_PRINTPRICE](state, printPrice) {
    state.printPrice = printPrice;
  },
  [RECORD_PRINT_QTY](state, printPhotoQty) {
    state.printPhotoQty = printPhotoQty;
  },
  [SET_LOADING](state, bol) {
    state.isLoading = bol;
  },
  [RECORD_EXTRAINFO](state,data){
    state.extraInfo = JSON.parse(data)
  },
  [HANDLE_TRANCE](state,pathname){
    let arr = state.pageStack;
    let index = arr.findIndex((n)=>n===pathname);
    if(index < 0){
      state.pageStack.push(pathname);
      state.actiBol=true;//是push进来的
    }else if (index === arr.length-1) {
      console.log("是懒加载路由导致路由前置守卫触发两次")
      state.actiBol=true;//是push进来的
    }else{
      state.pageStack = arr.slice(0,Number(index)+1);
      state.actiBol=false;//是返回来的
    }
    console.log('页面栈');
    console.log(state.pageStack);
  },
  [SETRULECOLOR](state,arr){
    //arr 里面有id和colors-[{id,colors}]
    state.ruleColor = arr.reduce((obj,item)=>{
      obj[item.id]=item.colors
      return obj
    },{})
    console.log("state.ruleColor:::",state.ruleColor)
  },
  [UPDATEGROUPLISTPRICE](state,price){
    let len = state.grouplist.length
    if(len===0){
      return
    }
    for(let i=0;i<len;i++){
      state.grouplist[i].singlePrice=price
    }
  },
  [ADDGROUPLIST](state,data){
    if(state.grouplist.length===0){
      state.grouplist.push(data)
    }else{
      let {id,printQty,colorIdx} =data
      for(let i=0,len=state.grouplist.length;i<len;i++){
        let {id:pid,printQty:ppq,colorIdx:pci} = state.grouplist[i]
        if(pid===id&&pci===colorIdx){
          state.grouplist[i].printQty=printQty+ppq
          return
        }
      }
      state.grouplist.push(data)
    }
  },
  [DELGROUPLIST](state,index) {
    state.grouplist.splice(index,1)
  },
  [EXTRAINIT](state){
    state.grouplist=[]
    state.extraAddState=''
  },
  [SETGROUPLISTNUM](state,data){
    console.log("num:::",data)
    let {index,num} = data
    state.grouplist[index].printQty=num
  },
  [SETPRINTEXTRA](state,data){
    state.printextra=data
  }
}